import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, MessageCircle } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="bg-[var(--text-dark)] text-white">
      <div className="container">
        {/* Main Footer */}
        <div className="py-12 grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-2">
            <img
              src="https://customer-assets.emergentagent.com/job_copper-recovery/artifacts/u6wvh72q_F.I.R.M.png"
              alt="FIRM s.a.s."
              className="h-16 w-auto object-contain mb-4"
            />
            <p className="text-gray-300 mb-4 max-w-md">
              Recupero e valorizzazione di materiali da cavi elettrici secondo i principi dell'economia circolare.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-lg mb-4">Link Rapidi</h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/chi-siamo"
                  className="text-gray-300 hover:text-[var(--copper-primary)] transition-colors"
                >
                  Chi Siamo
                </Link>
              </li>
              <li>
                <Link
                  to="/servizi"
                  className="text-gray-300 hover:text-[var(--copper-primary)] transition-colors"
                >
                  Servizi
                </Link>
              </li>
              <li>
                <Link
                  to="/processo"
                  className="text-gray-300 hover:text-[var(--copper-primary)] transition-colors"
                >
                  Processo Produttivo
                </Link>
              </li>
              <li>
                <Link
                  to="/sostenibilita"
                  className="text-gray-300 hover:text-[var(--copper-primary)] transition-colors"
                >
                  Sostenibilità
                </Link>
              </li>
              <li>
                <Link
                  to="/professionisti"
                  className="text-gray-300 hover:text-[var(--copper-primary)] transition-colors"
                >
                  Per Professionisti
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-semibold text-lg mb-4">Contatti</h4>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <Phone className="h-5 w-5 text-[var(--copper-primary)] mt-0.5" />
                <div className="flex items-center gap-3">
                  <a
                    href="tel:+390124572040"
                    className="text-gray-300 hover:text-[var(--copper-primary)] transition-colors"
                  >
                    0124 572040
                  </a>
                  <a
                    href="https://wa.me/390124572040"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-[#25D366] hover:text-[#20bd5a] transition-colors"
                    aria-label="WhatsApp"
                  >
                    <MessageCircle className="h-5 w-5" />
                  </a>
                </div>
              </li>
              <li className="flex items-start space-x-3">
                <Mail className="h-5 w-5 text-[var(--copper-primary)] mt-0.5" />
                <a
                  href="mailto:firm.recupero@gmail.com"
                  className="text-gray-300 hover:text-[var(--copper-primary)] transition-colors"
                >
                  firm.recupero@gmail.com
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin className="h-5 w-5 text-[var(--copper-primary)] mt-0.5" />
                <span className="text-gray-300">Italia, Piemonte, Canavese</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Footer */}
        <div className="border-t border-gray-700 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm">
              © {new Date().getFullYear()} FIRM s.a.s. - Tutti i diritti riservati
            </p>
            <div className="flex space-x-6 mt-4 md:mt-0">
              <a
                href="https://www.iubenda.com/privacy-policy/73606221"
                className="iubenda-white iubenda-noiframe iubenda-embed text-gray-400 hover:text-[var(--copper-primary)] text-sm transition-colors"
                title="Privacy Policy"
                data-testid="footer-privacy-link"
              >
                Privacy Policy
              </a>
              <a
                href="https://www.iubenda.com/privacy-policy/73606221/cookie-policy"
                className="iubenda-white iubenda-noiframe iubenda-embed text-gray-400 hover:text-[var(--copper-primary)] text-sm transition-colors"
                title="Cookie Policy"
                data-testid="footer-cookie-link"
              >
                Cookie Policy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};